<template>
    <div class="container header-margin">
        <div class="text-center p-2 text-color text-area">
            <h2 class="main_title">{{ $t('auth.signupTitleAube') }}</h2>
        </div>
    
        <div class="text-center p-2">
            <div v-if="this.message == 'userTokenDataWithin24H'" class="show-check-email-message" v-html="$t('auth.notLatestTokenText')"></div>
            <div v-if="this.message == 'notExistToken'" class="show-check-email-message" v-html="$t('auth.notExistTokenText')">
                <!-- トークンデータが存在しない -->
            </div>
            <div v-if="this.message == 'timeOverToken'" class="show-check-email-message" v-html="$t('auth.registrationTimeOverTokenAubeText')">
                <!-- トークンデータ24時間超過 -->
            </div>
            <div v-if="this.message == 'notLatestToken'" class="show-check-email-message" v-html="$t('auth.notLatestTokenText')">
                <!-- 最新ではないトークンデータ -->
            </div> 
        </div><br />
        <div class="text-center">
            <div class="pb-4 ">
                <a class="btn btn-primary text-center-btn" href="/" role="button">{{$t('auth.changeEmail.buttom') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'registration-error-module',

        created() {
            this.message = this.$route.query.message;
        }
    }
</script>

<style scoped>
    .text-color{
        color: #451493;
    }
    .text-area{
        padding-bottom: 20px;
    }
    .main_title{
        margin-bottom:15px;
    }
    .main_title{
        font-size: 1.575rem;
        margin-bottom: 0px;
    }
    .pre {
        white-space: pre-wrap;
    }
    .btn-primary{
        width: 115px;
        background: #451493;
        border-color:#451493;
        color: #FFF;
    }
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
